import React from "react";
import { Button } from "@/components/ui/button";
import { 
  MessageCircle, 
  ShoppingCart, 
  CreditCard, 
  Bitcoin,
  CircleDollarSign,
  Landmark
} from "lucide-react";
import { ProductCard } from "@/components/product-card";

export const HeroSection = () => {
  const paymentIcons = [
    { icon: CreditCard, color: "text-blue-400", label: "Credit Card" },
    { icon: Bitcoin, color: "text-orange-400", label: "Crypto" },
    { icon: CircleDollarSign, color: "text-blue-500", label: "PayPal" },
    { icon: Landmark, color: "text-green-400", label: "Bank Transfer" },
  ];

  return (
    <section 
      className="relative pt-24 pb-20 md:pt-32 md:pb-24 overflow-hidden"
    >
      <div className="container max-w-5xl mx-auto px-6 relative z-10">
        <div className="flex flex-col items-center text-center">
          <div className="mb-6">
            <div className="inline-flex items-center px-3 py-1.5 rounded-full bg-white/10 border border-white/20 text-xs font-medium text-white mb-6 animate-pulse">
              <span className="mr-2">Premium Gaming Solutions</span>
              <span className="inline-block w-1.5 h-1.5 rounded-full bg-purple-light"></span>
            </div>
          </div>
          
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold tracking-tight max-w-4xl mb-6 font-display text-white">
            Elevate Your <span className="text-gradient">Gaming</span> Experience
          </h1>
          
          <p className="text-purple-light/90 text-lg md:text-xl max-w-2xl mb-8">
            Premium cheats and tools designed to give you the competitive edge in your favorite games.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 mb-16">
            <Button 
              size="lg" 
              className="bg-purple-vivid hover:bg-purple-vivid/90 text-white"
            >
              <ShoppingCart className="mr-2 h-5 w-5" />
              Shop Now
            </Button>
            <Button 
              variant="outline" 
              size="lg"
              className="bg-black/40 border-white/10 text-white hover:bg-black/60"
            >
              <MessageCircle className="mr-2 h-5 w-5" />
              Join Discord
            </Button>
          </div>
          
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-8">
            Best Selling Products
          </h2>
          
          <div className="flex justify-center gap-8 mt-6 mb-32">
            <div className="max-w-[400px]">
              <ProductCard 
                name="Disconnect.wtf" 
                game="Rust" 
                description="Safest rust cheat which has never been detected."
                badge="BEST SELLER"
                imageSrc="https://bucket.cheatvault.net/products/rust-external-disconnect-cheat/1.png"
                billgangProductId="disconnect-rust"
                billgangDomain="indirectcheats.bgng.io"
                pricing={{
                  daily: "$8.00",
                  weekly: "$49.99",
                  monthly: "$149.99"
                }}
              />
            </div>
            
            <div className="max-w-[400px]">
              <ProductCard 
                name="Fluent.gg" 
                game="Rust" 
                description="The best Rust Rage cheat on the market."
                badge="NEW"
                imageSrc="https://cdn.lmarket.net/wp-content/uploads/2024/07/fluent.jpg"
                billgangProductId="fluent-rust"
                billgangDomain="indirectcheats.bgng.io"
                pricing={{
                  daily: "$9.99",
                  weekly: "$59.99",
                  monthly: "$169.99"
                }}
              />
            </div>
          </div>

          <div className="w-full bg-white/5 rounded-2xl p-8 border border-white/10">
            <h3 className="text-xl font-semibold text-white mb-2">Secure Payment Methods</h3>
            <p className="text-purple-light/70 mb-8">All transactions are processed securely through SellAuth</p>
            
            <div className="overflow-hidden">
              <div className="flex animate-scroll-x whitespace-nowrap">
                {[...Array(3)].map((_, i) => (
                  <div key={i} className="flex gap-16 items-center px-6">
                    {paymentIcons.map((item, index) => (
                      <div key={index} className="flex flex-col items-center gap-2 transition-all duration-300 hover:scale-110">
                        <div className={`p-4 rounded-xl bg-white/5 backdrop-blur-sm border border-white/10 ${item.color}`}>
                          <item.icon className="w-8 h-8" />
                        </div>
                        <span className="text-xs font-medium text-purple-light/80">{item.label}</span>
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
